import React from 'react';
import PropTypes from 'prop-types';
import { cc } from '../../modules/styles';

import './Loading.css';

function Loading({ className }) {
  return <div className={cc('Loading', className)} />;
}

Loading.propTypes = {
  className: PropTypes.string,
};

export default Loading;
